"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromJsonTimestamp = fromJsonTimestamp;
exports.fromTimestamp = fromTimestamp;
exports.toTimestamp = toTimestamp;

var _long = require("./long");

var _misc = require("./misc");

function toTimestamp(date) {
  var seconds = numberToLong(date.getTime() / 1000);
  var nanos = date.getTime() % 1000 * 1000000;
  return {
    seconds: seconds,
    nanos: nanos
  };
}

;

function fromTimestamp(t) {
  var millis = t.seconds.toNumber() * 1000;
  millis += t.nanos / 1000000;
  return new Date(millis);
}

;

var fromJSON = function fromJSON(object) {
  return {
    seconds: (0, _misc.isSet)(object.seconds) ? _long.Long.fromString(object.seconds) : _long.Long.ZERO,
    nanos: (0, _misc.isSet)(object.nanos) ? Number(object.nanos) : 0
  };
};

function fromJsonTimestamp(o) {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    // TODO should we put this all inline?
    // return fromTimestamp(Timestamp.fromJSON(o));
    return fromTimestamp(fromJSON(o));
  }
}

function numberToLong(number) {
  return _long.Long.fromNumber(number);
}